module.exports = __webpack_public_path__ + "static/media/bg-card.5323018d.jpg";